// Shared class list for the "active alarm(s)" chip: used identically by the Active groups table row
// (Alder column, Index.vue) and the detail modal header (DetailModalShell.vue). Single source so both
// stay in sync instead of drifting on independent copies of the same hardcoded colours.
export const ALARM_CHIP_CLASS =
    'inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-[#F1B5B0] bg-[#FEF3F2] px-2.5 py-0.5 text-[11px] font-bold text-[#D92D20] transition-colors hover:bg-[#FEE4E2]';
